import React from 'react'
import { LuChevronDown } from 'react-icons/lu'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { BulkUpdatePayload } from '@/redux/slices/referralsImportBase'

interface Props {
  hasUpdatableClients: boolean
  canPauseClientEmails: boolean
  bulkUpdateItems: (payload: BulkUpdatePayload) => void
  bulkUpdateSelectedOnly: boolean
}

const ClientHeaderDropdown: React.FC<Props> = ({
  hasUpdatableClients,
  canPauseClientEmails,
  bulkUpdateItems,
  bulkUpdateSelectedOnly,
}) => {
  if (!hasUpdatableClients && !canPauseClientEmails) {
    return null
  }

  const scope = bulkUpdateSelectedOnly ? 'selected' : 'all'

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline-secondary" size="icon-xs">
          <LuChevronDown />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent>
        {hasUpdatableClients && (
          <DropdownMenuGroup>
            <DropdownMenuLabel>Existing client data</DropdownMenuLabel>

            <DropdownMenuItem
              onClick={() =>
                bulkUpdateItems({
                  filter: { selected: bulkUpdateSelectedOnly },
                  data: { onClientDuplicate: 'update' },
                })
              }
            >
              <span>
                Mark <b className="font-semibold">overwrite data</b> in{' '}
                <b className="font-semibold">{scope}</b> clients
              </span>
            </DropdownMenuItem>

            <DropdownMenuItem
              onClick={() =>
                bulkUpdateItems({
                  filter: { selected: bulkUpdateSelectedOnly },
                  data: { onClientDuplicate: 'keep-original' },
                })
              }
            >
              <span>
                Mark <b className="font-semibold">keep existing data</b> in{' '}
                <b className="font-semibold">{scope}</b> clients
              </span>
            </DropdownMenuItem>
          </DropdownMenuGroup>
        )}

        {canPauseClientEmails && (
          <DropdownMenuGroup>
            <DropdownMenuLabel>Notifications</DropdownMenuLabel>

            <DropdownMenuItem
              onClick={() =>
                bulkUpdateItems({
                  filter: { selected: bulkUpdateSelectedOnly },
                  data: { hasPausedClientEmails: false },
                })
              }
            >
              <span>
                Mark <b className="font-semibold">enable notifications</b> in{' '}
                <b className="font-semibold">{scope}</b> clients
              </span>
            </DropdownMenuItem>

            <DropdownMenuItem
              onClick={() =>
                bulkUpdateItems({
                  filter: { selected: bulkUpdateSelectedOnly },
                  data: { hasPausedClientEmails: true },
                })
              }
            >
              <span>
                Mark <b className="font-semibold">pause notifications</b> in{' '}
                <b className="font-semibold">{scope}</b> clients
              </span>
            </DropdownMenuItem>
          </DropdownMenuGroup>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default ClientHeaderDropdown
